export default __webpack_public_path__ + "static/media/cooking.55a364c1.svg";